import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Gamezop | ألعاب مجاني للعب عبر الإنترنت بدون تحميا',
  desc: `Gamezop العب ألعاب مجانية عبر الإنترنت بدون تحميل على موقع.
أكثر من 200 لعبة مجانية للعب، تشمل الأكشن، المغامرات، الألعاب الكلاسيكية، الألغاز، السباقات، والمزيد. العب الآن!`,
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'ألعاب مجاني للعب عبر الإنترنت بدون تحميا',
    body: {
      text: [
        `العب أفضل الألعاب المجانية على Gamezop بدون تحميل!
        اختر لعبتك المفضلة من القائمة وابدأ اللعب في ثوانٍ. لدينا أكثر من 200 لعبة مجانية في فئات مثل الأكشن، المغامرات، الأركيد، الألغاز، السباق والمزيد. سواء كنت تلعب على الهاتف المحمول، الكمبيوتر الشخصي أو iOS، لدينا أفضل الألعاب لك`,
        `إذا كنت تشعر بالملل، فإن Gamezop توفر لك العديد من الخيارات الممتعة. قم ببناء الدفاعات لإيقاف الأعداء، صوب وأطلق النار على الأهداف، أو اقفز فوق العقبات. استمتع بألعاب مثيرة مثل Kingdom Fight, City Cricket, Fruity Fiesta وغير ذلك الكثير! ألعابنا مناسبة لجميع الأعمار—الأطفال، البالغون وكبار السن.
        `,
        `لا تحتاج إلى أجهزة متطورة للعب. ألعابنا تعمل بدون تحميل أو تثبيت، كل ما تحتاجه هو متصفح واتصال بالإنترنت. يمكنك اللعب على أجهزة الكمبيوتر، أجهزة اللابتوب، كروم بوك، الهواتف الذكية، الأجهزة اللوحية والمزيد.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: `ما هي أفضل الألعاب المجانية على الإنترنت؟`,
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: `ما هي الألعاب المجانية على الإنترنت للعب مع الأصدقاء؟`,
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: `ما هي أكثر أنواع الألعاب على الإنترنت شهرة؟`,
    body: {
      text: [],
      list: [
        {
          name: 'العاب مجنونة',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: `العاب لوحية`,
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: `العاب مغامرات`,
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'العاب ألغاز',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: `العاب اطلاق نار`,
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: `ما هو Gamezop؟`,
    body: {
      text: [
        `Gamezop هو منصة ألعاب بَلَج-إن-بلاي تتيح للتطبيقات والمواقع الإلكترونية دمج الألعاب الترفيهية بسلاسة، مما يعزز من تفاعل المستخدمين. إلى جانب الألعاب، تدير Gamezop منصات متخصصة أخرى: Quizzop للاختبارات التفاعلية، Astrozop للتوقعات والتنجيم، Criczop لنتائج الكريكيت الحية والتحديثات، وFeedzop للأخبار المنسقة. معًا، تقدم هذه المنصات مجموعة متنوعة من الحلول التي تلبي اهتمامات جماهير مختلفة.`,
        `أكثر من 8000 منتج في أكثر من 70 دولة يعتمدون على Gamezop ومنصاتها الفرعية، بما في ذلك علامات تجارية عالمية مثل Amazon، Samsung Internet، Snap، Tata Play، AccuWeather، وPaytm. لا تساعد هذه الحلول فقط في زيادة تفاعل المستخدمين، بل توفر أيضًا فرصًا جديدة لتحقيق الإيرادات. عملية الدمج سريعة ولا تستغرق أكثر من 30 دقيقة، مما يمكّن التطبيقات والمواقع من تقديم محتوى ممتع يشمل الألعاب، الاختبارات، التنجيم، الكريكيت، والأخبار.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'الأسئلة الشائعة',
  faqs: [
    {
      tag: 'h3',
      title: 'هل يمكنني لعب ألعاب مجانية بدون تثبيت؟',
      body: [`نعم، يمكنك لعب ألعاب مجانية بدون تثبيت أو تحميلها.`],
    },
    {
      tag: 'h3',
      title: `هل أحتاج إلى التسجيل للعب؟`,
      body: [`لا، لست بحاجة إلى التسجيل للعب الألعاب على Gamezop.com. يمكنك البدء في اللعب فورًا دون أي تسجيل.`],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/ar',
      },
    },
    {
      tag: 'h3',
      title: `هل من الآمن لعب الألعاب عبر الإنترنت؟`,
      body: [
        `نعم، من الآمن لعب الألعاب عبر الإنترنت على منصات موثوقة مثل Gamezop. لا تتطلب ألعابنا التنزيل، مما يقلل من مخاطر البرمجيات الضارة. نحن نركز على أمان المستخدم لضمان تجربة لعب آمنة دون التأثير على خصوصيتك أو أمان جهازك.`,
      ],
    },
    {
      tag: 'h3',
      title: `هل الألعاب المجانية مجانية حقًا؟`,
      body: [`نعم، الألعاب المجانية على Gamezop مجانية تمامًا. ومع ذلك، قد تحتوي هذه الألعاب على إعلانات لدعم المنصة.`],
    },
    {
      tag: 'h3',
      title: `هل هناك ألعاب مجانية لكبار السن عبر الإنترنت؟`,
      body: [
        `نعم، لدينا ألعاب مجانية لكبار السن يمكنك لعبها عبر الإنترنت، بما في ذلك Sudoku Classic، Solitaire Gold، Chess Grandmaster، والمزيد.`,
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
